import { styled } from "@mui/material/styles";
import React from "react";

import { StyledDivider } from "./divider.styled";

type DividerProps = {
  text?: string;
  orientation: "vertical" | "horizontal";
  textAlign?: "left" | "right";
};

const Divider = ({ text, textAlign, orientation }: DividerProps) => {
  const Root = styled("div")(({ theme }) => ({
    width: "100%",
    ...theme.typography.body2,
    "& > :not(style) + :not(style)": {
      marginTop: theme.spacing(2),
    },
  }));
  return (
    <Root>
      <StyledDivider textAlign={textAlign} orientation={orientation}>
        {text}
      </StyledDivider>
    </Root>
  );
};

export default Divider;
